export type CalendarView = "day" | "week" | "month";
export function dateInputValue(date: Date): string {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
}
export function calendarWindow(anchor: Date, view: CalendarView) {
  const from = new Date(
    anchor.getFullYear(),
    anchor.getMonth(),
    anchor.getDate(),
  );
  if (view === "week") from.setDate(from.getDate() - from.getDay());
  if (view === "month") from.setDate(1);
  const to = new Date(from);
  if (view === "month") to.setMonth(to.getMonth() + 1);
  else to.setDate(to.getDate() + (view === "week" ? 7 : 1));
  return { from, to };
}
/** The visible month includes six complete weeks, including adjacent-month dates. */
export function calendarFetchWindow(anchor: Date, view: CalendarView) {
  const range = calendarWindow(anchor, view);
  if (view !== "month") return range;
  range.from.setDate(range.from.getDate() - range.from.getDay());
  range.to = new Date(range.from);
  range.to.setDate(range.to.getDate() + 42);
  return range;
}
export function moveCalendarDate(
  anchor: Date,
  view: CalendarView,
  direction: -1 | 1,
) {
  return view === "month"
    ? new Date(anchor.getFullYear(), anchor.getMonth() + direction, 1)
    : new Date(
        anchor.getFullYear(),
        anchor.getMonth(),
        anchor.getDate() + direction * (view === "week" ? 7 : 1),
      );
}
